<app-lazy-dropdown
    [label]="label"
    [control]="control"
    placeholder="Select Board Name"
    [searchControl]="boardFilter"
    [items]="boardList"
    [totalCount]="totalBoardCount"
    [offset]="boardOffset"
    [paginationLimit]="paginationLimit"
    (loadMore)="getNextBoard()"
    (filterChange)="filterBoards($event)"
    [multiple]="multiple"
    [showClear]="showClear"
    (selectionChange)="onSelectionChange($event)"
></app-lazy-dropdown>
